import { notification } from "antd";

export const onError = (e: Error) => {
  notification.error({ message: e.message });
};
